import {entity} from "../rpc/api";
import EntryList = entity.EntryList;
import moment from "moment"

class EntryConvertResponse {

    public static from(from: entity.Entry): EntryConvertResponse {

        // Backend => FrontEnd における型変換
        const createdAtDate: Date = EntryConvertResponse.convertToDate(from.createdAt);

        return new EntryConvertResponse(
            from.customerID,
            from.projectID,
            createdAtDate,
        )
    }

    // Backend => FrontEnd における型変換　日付があればDate変換　なければ今日のDateを入れる
    private static convertToDate = (dateString: string): Date => {
        return (dateString) ? moment(dateString, "YYYY-MM-DD HH:II:SS").toDate() : moment().toDate()
    };

    constructor(public readonly customerID: string,
                public readonly projectID: string,
                public readonly createdAt: Date,
    ) {
    }

}

class EntryConvertResponseList {

    public static from(from: EntryList): EntryConvertResponseList {
        const items: EntryConvertResponse[] = [];

        from.items.map((item, index) => {
            return items.push(EntryConvertResponse.from(item as entity.Entry))
        });

        return new EntryConvertResponseList(
            items,
        )
    };

    constructor(
        public readonly items: EntryConvertResponse[],
    ) {
    };

}

export {
    EntryConvertResponse,
    EntryConvertResponseList,
}


// WEBPACK FOOTER //
// ./src/infra/api/service/entry_api_convert.ts